module.exports = __webpack_public_path__ + "img/icon-code-87f4c95f.svg";